<!--登记版面费-->
<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <div class="topbar m-b-25 d-flex flex-j-between">
        <div>
          <el-button size="small" type="primary" :disabled="!flag" @click="submit">批量登记出版信息</el-button>
        </div>

        <div class="searchBox">
          <el-input placeholder="稿件标题" v-model="f_title" class="input-with-select">
            <el-button slot="append" icon="el-icon-search" @click="loadData">搜索</el-button>
          </el-input>
        </div>
      </div>

      <el-row>
        <el-col :span="24">
          <el-table ref="tableData" :data="tableData" stripe @select-all="selAll" @selection-change="selChange" style="width: 100%">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column type="index" label="序号" width="60" align="center"> </el-table-column>
            <el-table-column prop="sn" label="稿件编号" width="100">
              <template slot-scope="scope">
                <span class="sn">{{ scope.row.sn }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="title" label="稿件标题" min-width="200">
              <template slot-scope="scope">
                <a href="#" style="float: right" class="download" @click="downLoadAttach(scope.row)">下载{{ getAttachName(scope.row) }}</a>
                <h3>{{ scope.row.title }}</h3>
              </template>
            </el-table-column>

            <el-table-column prop="bmf" label="版面页数" align="center" class-name="bmys" width="110">
              <template slot-scope="scope">
                <el-input-number :min="1" :max="100" :precision="1" :step="0.5" v-model="scope.row.publishPage" controls-position="right" @change="changePP($event, scope.row)"></el-input-number>
              </template>
            </el-table-column>

            <el-table-column v-if="$config.isCharge" prop="bmf" label="应收出版费" align="center" class-name="bmfy" width="140">
              <template slot-scope="scope">
                <el-input-number :min="0.01" :precision="2" v-model="scope.row.bmf" controls-position="right"></el-input-number>
              </template>
            </el-table-column>

            <el-table-column prop="bmf" label="拟发表时间" align="center" class-name="fbsj" width="140">
              <template slot-scope="scope">
                <el-date-picker v-model="scope.row.publishTime" type="month" placeholder="选择月" format="yyyy-MM" value-format="yyyy-MM"> </el-date-picker>
              </template>
            </el-table-column>

            <el-table-column prop="subjectName" :label="subName" width="90"></el-table-column>
            <el-table-column prop="authorName" label="作者" width="80"></el-table-column>

            <el-table-column prop="createTime" label="投稿时间" width="140" value-format="yyyy-MM-dd">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm") }}
              </template>
            </el-table-column>

            <!--el-table-column prop="dcRate1" label="查重结果" width="80">
              <template slot-scope="scope"> {{ getRate(scope.row.dcRate1, scope.row.dcRate2) }}% </template>
            </!--el-table-column-->
          </el-table>
        </el-col>
      </el-row>

      <div style="margin: 20px 0 0 -5px">
        <el-pagination background layout="sizes,prev, pager, next" :total="total" :page-size="pageSize" :page-sizes="[10, 20, 30, 50]" :current-page="curPage" @current-change="pageChange" @size-change="pageSizeChange"> </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import editorApi from "@/api/editor"
import attachUtil from "@/utils/attachUtil"
import attachApi from "@/api/attach"

export default {
  components: { PageHeader },
  data() {
    return {
      subName: process.env.VUE_APP_PLATFORM == "dx" ? "栏目" : "科目",
      headLinks: [{ path: "", title: "待登记出版信息稿件" }],
      subjects: [],
      f_subjectId: -1,
      f_title: "",
      curPage: 1,
      pageSize: 10,
      tableData: [],
      selData: [],
      total: 0,
      drawer: false,
      flag: false,
      curArticleId: 0,

      amounts: [],
      articleIds: [],
      letterNoticeTime: [],
      letterNoticePage: [],

      sfbz: 0,
    }
  },

  created() {
    this.sfbz = process.env.VUE_APP_PLATFORM == "dx" ? 1650 : 1200
  },

  mounted() {
    this.loadData()
  },

  methods: {
    changePP(e, row) {
      row.bmf = this.sfbz * e
    },

    getRate(rate1, rate2) {
      return rate2 > rate1 ? rate2 : rate1
    },

    pageChange(curPage) {
      this.curPage = curPage
      this.loadData()
    },

    pageSizeChange(val) {
      this.pageSize = val
      this.curPage = 1
      this.loadData()
    },

    loadData() {
      this.tableData = []
      editorApi.getChargeList(this.f_subjectId, this.f_title, 1, "id", "desc", this.curPage, this.pageSize).then((res) => {
        this.tableData = res.rows
        this.total = res.total
      })
    },

    selAll() {
      this.flag = this.$refs.tableData.selection.length > 0
    },
    selChange() {
      this.flag = this.$refs.tableData.selection.length > 0
    },

    getAttachName(item) {
      return item.alter1 != -1 ? "稿件修改件" : "稿件原稿"
    },

    downLoadAttach(item) {
      let attachId = item.fileId
      if (item.alter1 != -1 && item.alter1 != null) {
        attachId = item.alter1
      }

      let attachName = item.alter1 != -1 ? "稿件修改件" : "稿件原稿"

      attachApi.downArticle(attachId).then((res) => {
        if (res.type != "application/octet-stream") {
          this.$alert("下载失败，" + attachName + "不存在!", "错误", {
            confirmButtonText: "确定",
          })
        } else {
          attachUtil.download(res, item.sn + "-" + item.title + "【" + attachName + "】.docx")
        }
      })
    },

    submit() {
      this.selData = this.$refs.tableData.selection
      this.amounts = []
      this.articleIds = []
      this.letterNoticeTime = []
      this.letterNoticePage = []

      let vc = 0 //没有填写的记录数
      if (this.$config.isCharge) {
        this.selData.forEach((element) => {
          if (element.bmf != undefined && element.publishPage != undefined && element.publishTime != undefined) {
            this.amounts.push(element.bmf)
            this.articleIds.push(element.id)
            this.letterNoticeTime.push(element.publishTime)
            this.letterNoticePage.push(element.publishPage)
          } else {
            vc++
          }
        })
      } else {
        this.selData.forEach((element) => {
          if (element.publishPage != undefined && element.publishTime != undefined) {
            this.amounts.push(0)
            this.articleIds.push(element.id)
            this.letterNoticeTime.push(element.publishTime)
            this.letterNoticePage.push(element.publishPage)
          } else {
            vc++
          }
        })
      }

      if (vc == this.selData.length) {
        this.$message.warning("请填写完信息后再操作")
        return false
      }

      this.$confirm("将批量登记" + this.articleIds.length + "条记录的出版信息, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        closeOnClickModal: false,
        dangerouslyUseHTMLString: true,
      }).then(() => {
        //articleIds,amounts,letterNoticePage,letterNoticeTime
        editorApi.doCharge(this.articleIds, this.amounts, this.letterNoticePage, this.letterNoticeTime).then((res) => {
          if (res.code == 0) {
            this.drawer = false
            this.$notify.success({
              title: "成功",
              message: "登记成功！",
            })
            this.loadData()
            this.getStat()
          } else {
            this.$notify.error({
              title: "错误",
              message: res.msg,
            })
          }
        })
      })
    },
  },
}
</script>

<style scoped>
.dengJi {
  border: 1px solid #ccc;
  margin-bottom: 25px;
}

.searchBox::after {
  content: "";
  display: block;
  clear: both;
}

.el-table /deep/ th.col-bmf {
  background-color: #409eff !important;
}

.el-table /deep/ th.col-bmf > .cell {
  color: #fff;
}

.el-table--striped /deep/ td.col-bmf {
  background-color: #409eff !important;
}

td.bmys /deep/ .el-input-number .el-input__inner,
td.bmfy /deep/ .el-input-number .el-input__inner {
  text-align: left !important;
}

td.bmys .el-input-number.is-controls-right .el-input__inner {
  padding-left: 10px !important;
}

td.bmys .el-input-number--small {
  width: 90px !important;
}

td.bmfy .el-input-number--small {
  width: 120px !important;
}

td.fbsj .el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 110px;
}

.panelDj {
  width: calc(100vw - 200px);
  height: 400px;
  border: 1px solid #eee;
  background-color: #fff;
  padding: 15px;
  position: absolute;
  z-index: 800;
  bottom: 0;
}
</style>
